import * as firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyBP1Ij1SeJmEAvyju5UIdbU9ZtlA_s7d68",
  authDomain: "boilertrade-ad136.firebaseapp.com",
  projectId: "boilertrade-ad136",
  storageBucket: "boilertrade-ad136.appspot.com",
  messagingSenderId: "614415855825",
  appId: "1:614415855825:web:632b6ee50ca815b8e415f0",
  measurementId: "G-07TTRRGNMQ"
};

firebase.initializeApp(firebaseConfig);

export default firebase;